<template>
    <div class="m-lightbox" :class="status ? '_active': ''">
      <div class="m-lightbox--bg"></div>
      <div class="m-lightbox--close" @click="closeHelp()"></div>
      <div class="m-lightbox--content bg-green mx-auto">
        <div class="xsScroll" v-if="type === 'child' && !policy">
          <h5 class="white">諮詢管道</h5>
          <ul class="white">
            <li>1. 學校輔導室</li>
            <li>2. 113保護專線</li>
            <li>3. 1957福利專線</li>
            <li>4. 各縣市家庭教育中心</li>
            <li>5. 全國未成年懷孕諮詢專線：0800-257-085</li>
            <li>6. 免付費諮商：請洽詢各縣市心理衛生中心</li>
            <li>7. 各縣市家庭福利服務中心或社會福利服務中心</li>
            <li>8. 安心專線：1925(依舊愛我)、0800-788-995(請幫幫-救救我)</li>
            <li style="color: #FFFF05;">9. 各縣市家扶中心，或家扶兒童保護專線：0800-078585(您請幫我幫我)</li>
            <li>10. 踹貢少年專線服務(服務13至未免18歲青年)：0800-00-1769（一起來貢）</li>
            <li>11. 張老師專線：1980</li>
            <li>12. 生命線：1995</li>
          </ul>
        </div>
        <div class="xsScroll" v-if="type === 'parent' && !policy">
          <h5 class="white">諮詢管道</h5>
          <ul class="white">
            <li>1. 113保護專線</li>
            <li>2. 1957福利專線</li>
            <li>3. 各縣市家庭教育中心</li>
            <li>4. 男性關懷專線：0800-013-999</li>
            <li>5. 全國未成年懷孕諮詢專線：0800-257-085</li>
            <li>6. 免付費諮商：請洽詢各縣市心理衛生中心</li>
            <li>7. 各縣市家庭福利服務中心或社會福利服務中心</li>
            <li>8. 安心專線：1925(依舊愛我)、0800-788-995(請幫幫-救救我)</li>
            <li style="color: #FFFF05;">9. 全國照顧者免付費關懷專線：0800-507-272 (台語：有你真好真好)</li>
            <li>10. 各縣市家扶中心，或家扶兒童保護專線：0800-078585(您請幫我幫我)</li>
            <li>11. 爸媽call-in教養專線服務：0800-532-880（我想要，幫幫您）</li>
            <li>12. 家庭照顧者諮詢專線：0800-580-097(我幫您，您休息)</li>
            <li>13. 張老師專線：1980</li>
            <li>14. 生命線：1995</li>
          </ul>
        </div>
        <div class="xsScroll white" v-if="policy">
            <h5>財團法人台灣兒童暨家庭扶助基金會個人資料告知暨同意書</h5>
            <p>依據個人資料保護法第8條規定，告知 台端下列事項，敬請詳閱確認：</p>
            <ul class="tcf">
              <li>財團法人台灣兒童暨家庭扶助基金會(下稱本會)於執行章程所載之宗旨，包括：「提供家庭補助及兒童、青少年、身心障礙者及家庭福利服務事項」、「一般或身心障礙兒童、青少年之收容」、「國內外貧困兒童、青少年及國內貧困家庭之認養」、「接受各級政府委託辦理兒童、青少年、身心障礙者及家庭福利服務事項」、「其他與社會福利有關事項及學術研究」，以及「本會財產及人事管理等業務需要」等合理關聯之特定目的範圍內，蒐集、處理及利用包含但不限於 台端本人之姓名、出生年月日、國民身分證統一編號、護照號碼、特徵、指紋、婚姻、家庭、教育、職業、病歷、醫療、基因、性生活、健康檢查、犯罪前科、聯絡方式、財務情況、社會活動及其他得以直接或間接方式辯識個人之資料。</li>
              <li>個人資料利用之期間、地區：
                <ol>
                  <li>(一) 期間：除法令或本會規章辦法另有訂定外，為本會立案起至解散、清算止。</li>
                  <li>(二) 地區：包含但不限於中華民國領土 。</li>
                </ol>
              </li>
              <li>台端就本會保有您個人資料得行使下列權利：
                <ol>
                  <li>(一)得向本會查詢、請求閱覽或請求製給複製本；</li>
                  <li>(二)得向本會請求補充或更正；但必須為適當之釋明；</li>
                  <li>(三)得向本會請求停止蒐集、處理或利用或請求刪除；</li>
                  <li>(四)台端若委託他人辦理，另須出具委託書並同時提供受託人身份證明文件以供核對。若申請人不符前述規定，本會得請申請人補充資料，以為憑辦。</li>
                </ol>
              </li>
              <li>就 台端行使上開權利之事宜，均依法令、本會規章辦法及服務契約相關規定辦理，並應給付必要之成本費用。惟本會得依個人資料保護法第10條、第11條規定，執行業務所必須及法定保存期間等考量否准台端申請。</li>
              <li>台端不提供個人資料所致權益之影響：
                <p>您得自由選擇是否提供相關個人資料；惟您若拒絕提供或要求刪除相關個人資料，本會如因此無法進行必要之行政作業，得停止雙方服務關係，以利方案進行，兼維護您的個人資料保護。</p>
              </li>
            </ul>
            <hr>
            <ul class="tcf">
              <li>經 貴會向本人(或本人之法定代理人、受託人)告知上開事項，本人(或本人之法定代理人、受託人)已清楚瞭解 貴會蒐集、處理或利用本人個人資料之目的及用途。</li>
              <li>本人(或本人之法定代理人、受託人)同意依個人資料保護法第7條規定提供個人資料均屬正確，並主動補充最新正確資料予貴會及相關機關，作為特定目的範圍及公務、公益之蒐集、處理與利用。</li>
              <li>本告知事項本人(或本人之法定代理人、受託人)已詳細閱讀，並同意資料使用，以促進公益。</li>
            </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Lightbox',
  props: {
    type: String,
    status: Boolean,
    policy: Boolean
  },
  methods: {
    closeHelp () {
      this.$parent.isLightbox = false
      if (this.$parent.isPolicy) {
        setTimeout(() => {
          this.$parent.isPolicy = false
        }, 500)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.m-lightbox {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 104; //searching 105
    display: flex;
    // justify-content: center;     ie11 bug
    align-items: center;
    pointer-events: none;
    &--bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba($white, 0.7);
        opacity: 0;
        transition: 0.4s map-get($ease, 'IOquad');
    }
    &--close {
        position: absolute;
        top: 10px;
        right: 20px;
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 2;
        opacity: 0;
        transition: 0.4s map-get($ease, 'IOquad');
        &:after {
            position: absolute;
            content: '';
            width: 30px;
            height: 1px;
            transform: rotate(45deg);
            background: $black;
        }
        &:before {
            position: absolute;
            content: '';
            width: 30px;
            height: 1px;
            transform: rotate(-45deg);
            background: $black;
        }
    }
    &--content {
        position: relative;
        z-index: 2;
        width: calc(100% - 20px);
        opacity: 0;
        transform: translate3d(0, 10%, 0);
        transition: 0.4s map-get($ease, 'IOquad');
        padding: 40px 20px;
        border-radius: 20px;
        li{
          padding: 2.5px 0;
        }
        .xsScroll{
          height: 55vh;
          overflow-x: hidden;
          overflow-y: scroll;
        }
    }
    ul.tcf{
      padding-left: 45px;
      list-style: trad-chinese-informal;
    }
    @include respond-to(sm) {
        &--close {
            top: 30px;
            right: 50px;
            height: 40px;
            width: 40px;
            &:after,
            &:before {
                width: 40px;
            }
        }
        &--content {
            width: 80%;
            padding: 40px;
            // .xsScroll{
            //   height: auto;
            //   overflow: visible;
            // }
        }
    }
    @include respond-to(md) {
        &--close {
            // top: 50px;
            right: 80px;
            &:after,
            &:before {
                transition: 0.4s;
            }
            &:hover {
                &:after {
                    transform: scale(0.8) rotate(45deg);
                }
                &:before {
                    transform: scale(0.8) rotate(-45deg);
                }
            }
        }
        &--content {
            width: 60%;
            max-width: 720px;
        }
    }
    @include respond-to('1200') {
      &--content {
        width: 80%;
        max-width: 900px;
        padding: 60px 90px;
      }
    }
    &._active {
        pointer-events: visible;
        .m-lightbox--bg {
            opacity: 1;
        }
        .m-lightbox--close {
            opacity: 1;
        }
        .m-lightbox--content {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }
}

</style>
